<template>
    <div class="mx-auto mt-2 card-body">
    Please tick to accept the
    <a v-b-modal="'termsModal'" style="color: blue; text-decoration: underline; cursor: pointer;">Terms and Conditions</a>

    <div class="checkbox">
        <label id="terms_tick" for="terms1">
            <input type="checkbox" v-model="termsAccepted" @change="setTerms" id="terms1"/>
            <span class="checkbox-material"><span class="check"></span></span>
        </label>
    </div>

    <b-modal id="termsModal" title="Terms and Conditions">
        <div class="card card-body">
              <div v-html="terms"></div>
            </div>
    </b-modal>
	</div>

</template>

<script>

import EventBus from '../../events/event-bus'

export default {
  data() {
    return {
      terms: null,
      termsAccepted: false,
      readonly: this.$store.getters.getReadOnly
    };
  },

  props: ["event"],

  created() {
    var self = this;

    if (this.readonly){
      this.termsAccepted = true
      EventBus.$emit("selectTerms", this.termsAccepted);
    }

    this.$http.get("/legal_terms/" + this.event.id).then(function(response) {
      self.terms = response.data.terms;
    });
  },

  methods: {
    setTerms(){
      EventBus.$emit("selectTerms", this.termsAccepted);
    }
  }
};
</script>


